import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import unescapedText from 'I18n/utils/unescapedText';
export function buildFullAddress({
  location,
  remote
}) {
  const {
    country,
    full,
    streetLine1,
    streetLine2,
    locality,
    state,
    zip
  } = location;
  if (remote && country && !(streetLine1 || streetLine2 || locality || state || zip)) {
    const key = `SharedI18nStrings.countryCodes.${country}`;
    if (isValidI18nKey(key)) {
      return unescapedText(key);
    }
    return full;
  }
  const addressParts = ['streetLine1', 'streetLine2', 'locality', 'state', 'zip', 'country'].reduce((result, part) => {
    if (part === 'country' && country && country.trim() !== '') {
      // use full country name to ensure google map link redirects to /place url
      const key = `SharedI18nStrings.countryCodes.${location[part].trim()}`;
      result.push(unescapedText(key));
    } else if (location[part] && location[part].trim() !== '') {
      result.push(location[part].trim());
    }
    return result;
  }, []);
  return addressParts.join(', ');
}
export function buildFullCity({
  location,
  remote
}) {
  const {
    country,
    full,
    streetLine1,
    streetLine2,
    locality,
    state,
    zip
  } = location;
  if (remote && country && !(streetLine1 || streetLine2 || locality || state || zip)) {
    const key = `SharedI18nStrings.countryCodes.${country}`;
    if (isValidI18nKey(key)) {
      return unescapedText(key);
    }
    return full;
  }
  const addressParts = ['locality', 'state', 'country'].reduce((result, part) => {
    if (location[part]) {
      result.push(location[part]);
    }
    return result;
  }, []);
  return addressParts.join(', ');
}
export const getGoogleMapsUrl = address => {
  return `https://www.google.com/maps/search/?api=1&query=${address.replaceAll(',', '%2C').replaceAll(' ', '+')}`;
};